interface FormattableAddress {
	gate?: string | null;
	husnummer?: string | null;
	postnummer?: string | null;
	poststed?: string | null;
	asString?: string | null;
}

/** «Gate 1, 7713 Steinkjer». Bruker asString når API-et har gitt ferdig tekst. Tom streng uten adresse. */
export function formatAddress(address: FormattableAddress | null | undefined): string {
	if (!address) return "";
	if (address.asString) return address.asString;
	const street = [address.gate, address.husnummer].filter(Boolean).join(" ");
	return `${street}, ${address.postnummer ?? ""} ${address.poststed ?? ""}`.trim();
}
